import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { imgs } from "../../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { audiosAssets } from "../../../assets/audio";
import { imgInstructionTeam2 } from "../../../assets/imgIntruction/tema2";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ModalInfoPromotionV2 } from "../../../components/common/ModalInfoPromotionV2";
import { voicesTypeControl } from "../../../types/audioType";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	panelActivy: 2,
	dialogTwo: 3,
	panelInstructionOne: 4,
	dialogCoffeAmerican: 5,
	dialogCoffeCapuchino: 6,
	dialogCoffeKobalto: 7,
	win: 8,
};

const stepRayCaster = {
	Americano: steps.dialogCoffeAmerican,
	Capuchino: steps.dialogCoffeCapuchino,
	Kobalto: steps.dialogCoffeKobalto,
};

export const Team2SubtopicTwoActivityTwo = () => {
	const dispatch = useDispatch()
	const navigator = useNavigate();
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 2);
	const stepSelectRayCaster = useRef(0);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 2');
			ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act2_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicTwo.clickedRayCaster, (step) => {
		const clickRayCaster = stepRayCaster[step];
		if (clickRayCaster === undefined) {
			return;
		}

		const isNextMove = stepSelectRayCaster.current === clickRayCaster;

		if (!isNextMove) {
			return;
		}

		if (clickRayCaster === steps.dialogCoffeAmerican) {
			setUiToShow(steps.dialogCoffeAmerican);
		}

		if (clickRayCaster === steps.dialogCoffeCapuchino) {
			setUiToShow(steps.dialogCoffeCapuchino);
		}

		if (clickRayCaster === steps.dialogCoffeKobalto) {
			setUiToShow(steps.dialogCoffeKobalto);
		}
	});

	const hiddenSelectObject = (stepCaster = 0) => {
		const foundEntry = Object.entries(stepRayCaster).find(([key, value]) => value === stepCaster);
		if (!foundEntry) {
			console.log("no se enctro");
			return;
		}
		const [key] = foundEntry;
		ObserverEmitter.emit(EVENTS.team2.subtopicTwo.stepUseRayCaster, key);
		stepSelectRayCaster.current = stepCaster;
		setUiToShow(steps.hiddenUI);
	};


	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicTwo.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Operación Maquinas de café Tamaños de vasos" />
					<DialogBarNew
						dialog={"¿Sabías que contamos con diferentes tamaños para nuestras bebidas?"}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivy);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelActivy && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act2_a02T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activityTwo.moveCashRegister);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={"Los tamaños disponibles para que un cliente adquiera su café son: mediano (12 onzas), grande (16 onzas) y jumbo (20 onzas)."}
						percentage={"50%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelInstructionOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.panelInstructionOne && (
				<>
					<PanelInstrucionHands
						text="Toca sobre los objetos para obtener información."
						action={() => {
							hiddenSelectObject(steps.dialogCoffeAmerican);
						}}
						img={imgInstructionTeam2.team2_sub2_act_2_01}
					/>
				</>
			)}
			{uiToShow === steps.dialogCoffeAmerican && (
				<>
					<BarStatusActivies activities={tasksList} />
				</>
			)}
			{uiToShow === steps.dialogCoffeAmerican && (
				<ModalInfoPromotionV2
					title={"Café Americano"}
					description={
						"Es una opción clásica y popular en todo el mundo. Se prepara añadiendo agua caliente a un espresso simple, lo que da como resultado un vaso de café más suave en comparación con un espresso puro. En Oxxo puedes encontrar 4 versiones de este café: Clásico, Descafeinado, Sabor a Mezclas Mexicanas e incluso Intenso, que es un americano un poquito más cargado para los paladares que gustan de un sabor más fuerte."
					}
					url={imgs.coffeamericano}
					callback={() => {
						hiddenSelectObject(steps.dialogCoffeCapuchino);
					}}
				></ModalInfoPromotionV2>
			)}
			{uiToShow === steps.dialogCoffeCapuchino && (
				<ModalInfoPromotionV2
					title={"Café Capuccino"}
					description={
						"Una deliciosa combinación de espresso, leche vaporizada y espuma de leche. Es una bebida más indulgente y cremosa que se ha vuelto muy popular en todo el mundo.Esta mezcla crea una bebida equilibrada con un rico sabor a café y una textura suave."
					}
					url={imgs.coffecapuchino}
					callback={() => {
						hiddenSelectObject(steps.dialogCoffeKobalto);
					}}
				></ModalInfoPromotionV2>
			)}
			{uiToShow === steps.dialogCoffeKobalto && (
				<ModalInfoPromotionV2
					title={"Café Kobalto"}
					description={
						"Una opción interesante y única en OXXO. Se trata de un café de sabor intenso, elaborado a partir de granos de café arábica y robusta cuidadosamente seleccionados. Es una mezcla exclusiva de OXXO que ofrece una experiencia de café más audaz y vigorizante. El Kobalto se caracteriza por su aroma rico y su sabor profundo, con una mayor concentración de cafeína para aquellos que buscan un impulso extra de energía."
					}
					url={imgs.coffekobalto}
					callback={() => {
						setUiToShow(steps.win)
					}}
				></ModalInfoPromotionV2>
			)}
			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Conocer nuestros productos a profundidad te ayudará a atender mejor a los clientes."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema2,
								})
							);
							navigator("/home2/tema2/subtema2/activityThree");
						}}
					/>
				</>
			)}
		</>
	);
};
